export const environment = {
  production: false,
  interceptedHosts: ['morebooks.shop'],
  oauth: 'https://morebooks.shop/oauth/',
  i18n: 'https://morebooks.shop/i18n/',
  graphQL: 'https://morebooks.shop/graphql',
};
